var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"JOB-ITEM"},[_c('div',{staticClass:"d-flex p-1 p-2:t"},[_c('div',{staticClass:"d-flex fd-column jc-between flex-1-1 m-x-1 m-x-2:t"},[_c('div',{staticClass:"GHOST-BOX x-pulse m-b-1"}),_c('div',{staticClass:"GHOST-BOX SMALL x-pulse"})])])])
}]

export { render, staticRenderFns }